import { createRouter, createWebHistory } from 'vue-router'
import util from '@/util'
import HomeView from '@/views/HomeView.vue'

import Usuarios from '@/views/Usuarios.vue'
import Empresas from '@/views/Empresas.vue'

import Grupos from '@/views/Grupos.vue'
import Subgrupos from '@/views/Subgrupos.vue'

import Funcoes from '@/views/Funcoes.vue'
import Colaborador from '@/views/Colaborador.vue'
import Jornadas from '@/views/Jornadas.vue'
import Escalas from '@/views/Escalas.vue'
import Feriados from '@/views/Feriados.vue'

import RegistrosDePonto from '@/views/RegistrosDePonto.vue'
import RelespelhoPonto from '@/views/relatorios/RelespelhoPonto.vue'
import Justificativas from '@/views/justificativas.vue'

import ExportarRegistros from '@/views/ExportarRegistros.vue'
import Zonas from '@/views/Zonas.vue'
import Terminais from '@/views/Terminais.vue'

const routes = [
  { path: '/',                 name: 'home',              component: HomeView,          meta: { titulo: 'Painel' } },
  { path: '/usuarios',         name: 'Usuarios',          component: Usuarios,          meta: { titulo: 'Usuários', perm: 'usuarios' } },
  { path: '/empresas',         name: 'Empresas',          component: Empresas,          meta: { titulo: 'Empresas e filiais', perm: 'empresas' } },
  { path: '/grupos',           name: 'Grupos',            component: Grupos,            meta: { titulo: 'Grupos', perm: 'cadastros' } },
  { path: '/subgrupos',        name: 'Subgrupos',         component: Subgrupos,         meta: { titulo: 'Subgrupos', perm: 'cadastros' } },
  { path: '/funcoes',          name: 'Funcoes',           component: Funcoes,           meta: { titulo: 'Funções', perm: 'cadastros' } },
  { path: '/colaboradores',    name: 'Colaborador',       component: Colaborador,       meta: { titulo: 'Colaboradores', perm: 'colaboradores' } },
  { path: '/jornadas',         name: 'Jornadas',          component: Jornadas,          meta: { titulo: 'Jornadas de trabalho', perm: 'jornadas' } },
  { path: '/escalas',          name: 'Escalas',           component: Escalas,           meta: { titulo: 'Escalas e exceções', perm: 'escalas' } },
  { path: '/feriados',         name: 'Feriados',          component: Feriados,          meta: { titulo: 'Feriados', perm: 'feriados' } },
  { path: '/registrosdeponto', name: 'RegistrosDePonto',  component: RegistrosDePonto,  meta: { titulo: 'Registros de ponto', perm: 'registros' } },
  { path: '/relespelhoponto',  name: 'RelespelhoPonto',   component: RelespelhoPonto,   meta: { titulo: 'Espelho de ponto', perm: 'espelho' } },
  { path: '/justificativas',   name: 'Justificativas',    component: Justificativas,    meta: { titulo: 'Justificativas', perm: ['justificativas', 'justificativas_aprovar'] } },
  { path: '/exportar',         name: 'Exportarregistros', component: ExportarRegistros, meta: { titulo: 'Arquivos fiscais (AFD/AEJ)', perm: 'fiscal' } },
  { path: '/zonas',            name: 'Zonas',             component: Zonas,             meta: { titulo: 'Zonas', perm: 'zonas' } },
  { path: '/terminais',        name: 'Terminais',         component: Terminais,         meta: { titulo: 'Relógios itinerantes (tablets)', perm: 'terminais' } },

  // Relógio de ponto itinerante: tela pública para o tablet corporativo.
  {
    path: '/ponto-itinerante',
    name: 'PontoItinerante',
    component: () => import(/* webpackChunkName: "itinerante" */ '@/views/PontoItinerante.vue'),
    meta: { publico: true, titulo: 'Batida de ponto itinerante' },
  },
  { path: '/batida-itinerante', redirect: '/ponto-itinerante' },

  { path: '/:pathMatch(.*)*', redirect: '/' },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Tela sem permissão: vai para o painel (que mostra uma tela de boas-vindas
// quando o usuário também não pode ver os indicadores).
router.beforeEach((to) => {
  if (to.meta.publico || !util.sessao()) return true
  if (to.meta.perm && !util.pode(to.meta.perm)) return to.path === '/' ? true : '/'
  return true
})

router.afterEach((to) => {
  document.title = (to.meta.titulo ? to.meta.titulo + ' · ' : '') + 'Clockin'
})

export default router
